<template>
    <!-- 適用店家 and 品牌的門市資訊 -->
    <div>
        <navigation-bar Back Bell/>
        <div class="main container">
            <div class="list-style" v-for="(item, index) in dataList" :key="index"
                 @click="goStoreInfo(item)">

                <el-image :src="item.imgUrl" fit="cover" class="pic2 mr-3" v-if="item.imgUrl!==''"/>
                <el-image :src="require('@/assets/images/default_image.svg')" fit="cover" class="pic2 mr-3" v-else/>

                <div class="content">
                    <h2>{{item.name === "" ? item.brandName : (item.brandName === "" ? item.name : item.brandName+"-"+item.name)}}</h2>
                    <div class="phone-btn">
                        <a @click.stop="$public.callTel(item.tel)" v-if="item.tel !== ''">
                            <img src="@/assets/images/phone.svg">
                            <span>{{item.tel}}</span>
                        </a>
                    </div>
                    <div class="location-btn">
                        <a @click.stop="onClickLocationBtn(item.lat, item.lng, item.googleMapUrl)" v-if="item.city !== ''">
                            <img src="@/assets/images/location_blue.svg">
                            <span>{{item.city}}{{item.township}}{{item.address}}</span>
                        </a>
                    </div>
                </div>
                <!--            <p class="distance"><img src="@/assets/images/location_blue_line.svg">{{getFloatFix(item.distance)}} km</p>-->
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'UsefulStore',
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        data() {
            return {
                dataToken: this.isWeb? (this.dataTokenWeb.dataToken ?? "" ): (this.$route.query.dataToken ?? ""),
                dataObject: {},
                type: this.isWeb? this.dataTokenWeb.type : this.$route.query.type,
                id:  this.isWeb? this.dataTokenWeb.id :this.$route.query.id,
                dataList: [],
                groupDataLIst: [],
            }
        },
        created() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (!this.$public.notNull(this.id) && this.dataObject.usedType === "UsefulStoreList" && this.dataObject.id > 0) {
                    this.type = this.dataObject.type
                    this.id = this.dataObject.id
                }
            } catch (e) {
                this.dataObject = {}
            }

            this.setupData();
        },
        methods: {
            setupData() {
                if (this.type === 'coupon') {
                    this.$http.fetchWithAuthEncrypt`CouponUseStoreList${{
                        'id': parseInt(this.id),
                    }}
                    ${json => {
                        if (json.status) {
                            try {
                                json.data = this.$crypto.decryptObjectText(json.data)
                            } catch (e) {
                                //
                            }
                            this.dataList = json.data;
                        }

                    }}`;
                } else if (this.type === 'brand') {
                    this.$route.meta.title = "門市資訊";
                    this.$http.fetch`GetBrandStoreList${{
                        'brandId': parseInt(this.id),
                    }}
                    ${json => {
                        this.dataList = json.storeList;
                    }}`;

                } else if (this.type === 'loyaltyCard') {
                    this.$http.fetchWithAuth`GetLoyaltyCardStoreUseList${{
                        'id': parseInt(this.id),
                    }}
                    ${json => {
                        this.dataList = json.data;
                    }}`;
                } else if (this.type === 'rewardPoint') {
                    this.$http.fetchWithAuthEncrypt`GetRewardPointStoreUseList${{
                        'id': parseInt(this.id),
                    }}
                    ${json => {
                        this.dataList = json.data;
                    }}`;
                }
            },
            getFloatFix(distance) {
                let num = parseFloat(distance);
                return num.toFixed(2); // 輸出結果為 2.45
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {
                // console.log(`onClickLocationBtn lat: ${lat}, lng: ${lng}, googleMapUrl: ${googleMapUrl}`);
                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);
                    // console.log(`param lat: ${param.googleMapLat}, lng: ${param.googleMapLng}, googleMapUrl: ${param.googleMapStoreInfoData}`);
                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },
            goStoreInfo(item) {
                if(item.id > 0 && !this.isWeb) {
                    //APP才會跳分店，網頁版不跳分店
                    this.$router.push({name: 'StoreInfo', query:{id: item.id}})
                }
            }
        },

    }
</script>

<style lang="less" scoped>
    .list-style{
        margin: 0 !important;
        .pic2 {
            width: 88px!important;
            height: 88px!important;
        }
    }
</style>